import { Action } from '../actions';

const defaultState = {
  loading: true,
  saved: false,
  error: false,
  errorMessage: null,
};

const checkError = (action) => {
  if (!action.payload || !action.payload.body) {
    return {};
  }

  const { status, body } = action.payload;
  if (body?.error) {
    return {
      entryId: body.entryId || '0',
      doneMismatches: false,
      loading: false,
      error: true,
      errorMessage: body.errorMessage,
    };
  }

  let stationDetails = body.station;
  let potentialMatchesDetails = body.potentialLocations;
  const { singlePoi, entryId, saved } = body;
  let error = false;
  let doneMismatches = body.doneMismatches || false;
  let errorMessage = null;
  if (status === 404) {
    stationDetails = null;
    potentialMatchesDetails = null;
    doneMismatches = true;
  } else if (status >= 400) {
    stationDetails = null;
    potentialMatchesDetails = null;
    error = true;
    errorMessage = body.message || `${status} Error`;
  }

  return {
    singlePoi,
    stationDetails,
    potentialMatchesDetails,
    saved,
    entryId,
    doneMismatches,
    error,
    errorMessage,
    loading: false,
  };
};

export default function wexmismatches(wexMatcherState = defaultState, action) {
  switch (action.type) {
    case Action.Payment.WexMismatch.GetWexMismatchCompleted:
    case Action.Payment.WexMismatch.SaveWexMatchCompleted: {
      return {
        ...wexMatcherState,
        ...checkError(action),
      };
    }
    default:
      break;
  }
  return wexMatcherState;
}
